import { Box, Grid, List, Typography } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import { Trans } from "react-i18next";
import i18next from "../../../../assets/i18n/i18n";
import "./login-by-sp.scss";
import Dot from "../../../../assets/images/png/Dot.png";
import LoginItsmeOnly from "../login-itsme-only/login-itsme-only";

type LoginBySpProps = {
    sp: string;
    spFull: string;
    authType: string[];
    acs: string;
};

const LoginBySp = ({ spFull, sp, acs, authType }: LoginBySpProps): React.ReactElement => {
    const loginItsmeOnly = () => {
        return (
            <Box>
                <Grid item xs={12} className="info-text info-text-text">
                    {i18next.t("LoginPage.LoginBySp.OnlyItsme.Text1")}
                </Grid>
                <LoginItsmeOnly spFull={spFull} acs={acs} />
            </Box>
        );
    };

    const textInformation = () => {
        return (
            <Box>
                <Grid item xs={12} className="info-text info-text-text">
                    {i18next.t("LoginPage.LoginBySp.InfoText.Text1")}
                </Grid>
                <Grid item xs={12} className="info-text info-text-text">
                    <List>
                        <ListItem>
                            <ListItemIcon style={{ marginBottom: "4em !important" }}>
                                <img src={Dot} alt="dot" className="le-dot-1" />
                            </ListItemIcon>
                            <ListItemText>
                                <Typography className="info-text info-text-text">
                                    <Trans i18nKey="LoginPage.LoginBySp.InfoText.LogInSecurely">
                                        it is now possible
                                        <strong>to log in securely</strong>, without installing the Portima Connect
                                        application, via itsme! This gives you access to the{" "}
                                        <strong>full application</strong>.
                                    </Trans>
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon style={{ marginBottom: "1em !important" }}>
                                <img src={Dot} alt="dot" className="le-dot-2" />
                            </ListItemIcon>
                            <ListItemText>
                                <Typography className="info-text info-text-text">
                                    <Trans i18nKey="LoginPage.LoginBySp.InfoText.Email">
                                        email and password, <strong>limited access</strong>
                                        without editing rights.
                                    </Trans>
                                </Typography>
                            </ListItemText>
                        </ListItem>
                    </List>
                </Grid>
            </Box>
        );
    };

    return (
        <Grid container justifyContent="center" className="info-text-container">
            <Grid item xs>
                <Grid container justifyContent="center">
                    <Grid item xs={12} className="info-text info-text-header">
                        <Trans i18nKey="LoginPage.LoginBySp.InfoText.Header">Log in to {{ sp }}</Trans>
                    </Grid>

                    {authType.length < 2 && authType.includes("EXT[oAuth/itsme]")
                        ? loginItsmeOnly()
                        : textInformation()}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LoginBySp;
